import { t } from 'ember-intl';

<template>
  <div class="invitation-banner">
    {{t "pages.login.join-invitation" organizationName=@organizationName}}
  </div>
</template>
